<template>
  <v-card
    elevation="10"
    width="100%"
    :loading="isLoading"
  >
    <v-card-title>
      Transações
      <v-spacer/>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
      >
      </v-text-field>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="isLoading"
        :loading="isLoading"
        type="table"
        class="mx-auto flex-fill"
        width="100%"
      />
      <v-scale-transition>
        <v-data-table
          v-if="!isLoading"
          :headers="transactionsHeader"
          :items="transactionsData"
          :search="search"
          show-expand
          :expanded.sync="expanded"
          item-key="key"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:body.prepend>
            <tr>
              <td/>
              <td/>
              <td/>
              <td>
                <v-select
                  v-model="searchStatus"
                  multiple
                  hide-details
                  clearable
                  label="Status"
                  small-chips
                  deletable-chips
                  outlined
                  dense
                  :items="transactionStatusFilterList"
                  class="flex"
                >
                </v-select>
              </td>
              <td/>
            </tr>
          </template>
          <template v-slot:item.description="{ item }">
            Pedido: <span class="blue--text">#{{item.description}}</span>
          </template>
          <template v-slot:item.flFinalPrice="{ item }">
            {{item.flFinalPrice | toFixedWithComma}}
          </template>
          <template v-slot:item.dhCreated="{ item }">
            <span class="blue--text text--darken-4">{{item.dhCreated | formatDatetime}}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              :color="item.status | statusColor"
            >
              <span class="text--white">{{item.status | statusText}}</span>
            </v-chip>
          </template>
          <template v-slot:item.postPayLink="{ item }">
            <v-btn
              v-if="item.postPayLink"
              :href="item.postPayLink['url_boleto']"
              target="_blank"
              :disabled="item.status === 'CANCELLED'"
              icon
              outlined
            >
              <v-icon>mdi-barcode</v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ item, headers }">
            <td
              :colspan="headers.length"
              class="pa-1"
            >
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                  <tr
                    v-for="postProcessing in item.shoppingCart['post_processing_cart']"
                    :key="postProcessing['id_shopping_cart_post_processing']"
                  >
                    <td>{{postProcessing["str_name"]}}</td>
                    <td v-if="chargeTypeIsCredits">{{currencySymbol}} {{postProcessing["fl_final_price"] | toFixedWithComma}}</td>
                  </tr>
                  <tr
                    v-for="processing in item.shoppingCart['processing_cart']"
                    :key="processing['id_shopping_cart_processing']"
                  >
                    <td>{{processing["str_name"]}}</td>
                    <td>{{currencySymbol}} {{processing["fl_final_price"] | toFixedWithComma}}</td>
                  </tr>
                  <tr
                    v-for="subscription in item.shoppingCart['subscription_cart']"
                    :key="subscription['id_shopping_cart_subscription']"
                  >
                    <td>{{subscription["str_name"]}}</td>
                    <td>{{currencySymbol}} {{subscription["fl_final_price"] | toFixedWithComma}}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </td>
          </template>
        </v-data-table>
      </v-scale-transition>
    </v-card-text>
  </v-card>
</template>

<script>
  import {forEach, includes} from "lodash/collection"
  import {
    TRANSACTION_STATUS_DESCRIPTION,
    TRANSACTION_STATUS_FILTER_LIST,
  } from "../../helpers/transactions/constants"
  import moment from "moment"
  import {isEmpty} from "lodash/lang"
  import {listTransactions} from "../../api/api-billing"

  export default {
    name: "Transactions",
    data: () => ({
      isLoading: true,
      search: null,
      searchStatus: [],
      transactionsData: [],
      expanded: [],

      sortBy: "dhCreated",
      sortDesc: true
    }),
    methods: {
      getTransactionDescription(item) {
        return item["cd_reference"]
      },
    },
    filters: {
      statusText(status) {
        if (!TRANSACTION_STATUS_DESCRIPTION[status])
          return "Nenhum"
        return TRANSACTION_STATUS_DESCRIPTION[status].text
      },
      statusColor(status) {
        if (!TRANSACTION_STATUS_DESCRIPTION[status])
          return "grey"
        return TRANSACTION_STATUS_DESCRIPTION[status].color
      },
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      },
      formatDatetime(date) {
        return moment(date).format("DD/MM/YYYY")
      }
    },
    created() {
      //TODO: Fazer tela de planos
      this.$appMng.setTitle("Financeiro")
      listTransactions(this.$apiAuth.getAuthToken())
        .then(res => {
          const transactions = res.data.data
          forEach(transactions, obj => {
            this.transactionsData.push({
              key: obj["cd_reference"],
              description: this.getTransactionDescription(obj),
              flFinalPrice: obj["fl_final_price"],
              dhCreated: obj["dh_created"],
              status: obj["ab_status"],
              postPayLink: obj["boleto_bancario"],
              shoppingCart: obj["shopping_cart"]
            })
          })
          this.isLoading = false
        })
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },      
      transactionsHeader() {
        const currencySymbol = this.$appMng.isIntl ? "USD" : "R$"
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits') {
          return [
            {
              text: "Descrição",
              align: "left",
              sortable: false,
              value: "description",
            },
            {text: `Valor (${currencySymbol})`, value: "flFinalPrice"},
            {text: "Data da Fatura", value: "dhCreated"},
            {
              text: "Status",
              value: "status",
              width: "200px",
              filter: value => {
                if (isEmpty(this.searchStatus)) return true

                return includes(this.searchStatus, value)
              },
            },
            {text: "Boleto", value: "postPayLink"},
            {text: '', value: 'data-table-expand'},
          ]
        } else {
          return [
            {
              text: "Descrição",
              align: "left",
              sortable: false,
              value: "description",
            },
            {text: "Data do pedido", value: "dhCreated"},
            {
              text: "Status",
              value: "status",
              width: "200px",
              filter: value => {
                if (isEmpty(this.searchStatus)) return true

                return includes(this.searchStatus, value)
              },
            },
            {text: 'Filtro status', value: ''},
            {text: '', value: 'data-table-expand'},
          ]
        }
      },     
      transactionStatusFilterList() {
        return TRANSACTION_STATUS_FILTER_LIST
      },
      currencySymbol() {
        if (this.$appMng.isIntl)
          return "$"
        return "R$"
      }
    },
  }
</script>

<style scoped>

</style>
